import { Dispatch, SetStateAction } from "react";
import api from "../../../utils/api";
import { ADD_ITEM_LOOKUP, UPDATE_ITEM_LOOKUP } from "../../../utils/endpoints";
import { auxiliaresLookUps } from "../data/AuxiliaresLookUps";
import { fetchAuxiliaresData } from "../data/fetchAuxiliaresData";

export const handleSubmitItem = async (
  data: any,
  table: string,
  buttonTitle: string,
  idItem: string | undefined,
  setDataTable: Dispatch<SetStateAction<any[]>>,
  setOriginalDataTable: Dispatch<SetStateAction<any[]>>,
  addToast: (options: {
    title: string;
    description: string;
    status: "success" | "error";
  }) => void,
  setIsOpen: (isOpen: boolean) => void,
) => {
  const tableIndex = +table - 1;
  const entityName = auxiliaresLookUps[tableIndex].entityName;
  const bodyRequest = {
    Code: data.code,
    Name: data.name,
    EntityType: entityName,
    ...(auxiliaresLookUps[tableIndex].getParent && {
      ParentId: data.province.id.toString(),
    }),
  };

  try {
    const endpoint =
      buttonTitle === "Criar item" ? ADD_ITEM_LOOKUP : UPDATE_ITEM_LOOKUP;
    const method = buttonTitle === "Criar item" ? api.post : api.patch;
    const response = await method(
      endpoint,
      buttonTitle === "Criar item"
        ? bodyRequest
        : { ...bodyRequest, id: idItem },
    );

    if (response.status === 200) {
      addToast({
        status: "success",
        title: "Sucesso",
        description:
          buttonTitle === "Criar item" ? "Item criado" : "Alterações Guardadas",
      });
      await fetchAuxiliaresData(tableIndex, setDataTable, setOriginalDataTable);
      setIsOpen(false);
    } else {
      throw new Error();
    }
  } catch (error) {
    console.error("API Error:", error);
    addToast({
      status: "error",
      title: "Erro",
      description: `Ocorreu um erro ao ${
        buttonTitle === "Criar item" ? "criar" : "alterar"
      } o item`,
    });
  }
};
